// 阿拉伯数字转中文数字 只支持两位数
export function numberfilter(num) {
  const changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  const unit = ['', '十']
  num = parseInt(num)
  const getWan = (temp) => {
    const strArr = temp.toString().split('').reverse()
    let newNum = ''
    for (let i = 0; i < strArr.length; i++) {
      strArr[i] = Number(strArr[i])
      newNum = (i === 0 && strArr[i] === 0 ? '' : (i > 0 && strArr[i - 1] === 0 && strArr[i] === 0 ? '' : (i > 0 && strArr[i] === 1 ? '' : changeNum[
        strArr[i]]) + (strArr[i] === 0 ? unit[0] : unit[i]))) + newNum
    }
    return newNum
  }
  return getWan(num)
}

// 获取当前月份的第一天、当天和最后一天，数组【起，今天，始】
export function getFirstNowLastDay() {
  const now = new Date()
  const year = now.getFullYear()
  let month = now.getMonth() + 1
  let day = now.getDate()
  // 补零
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (day >= 1 && day <= 9) {
    day = '0' + day
  }
  // 第一天
  const firstDate = year + '-' + month + '-' + '01'
  // 当天
  const sysDate = year + '-' + month + '-' + day
  // 最后一天
  let new_year = year
  let new_month = month + 1 // 取下一个月的第一天，方便计算（最后一天不固定）
  if (month > 12) { // 如果当前大于12月，则年份转到下一年
    new_month -= 12 // 月份减
    new_year++ // 年份增
  }
  const lastDay = new Date(new_year, new_month, 0).getDate()
  const lastDate = year + '-' + month + '-' + lastDay

  const returnArr = [firstDate, sysDate, lastDate]
  return returnArr
}

// 设置树数据是否可选择
export function treeDisabled(s, bool) {
  const R = (s, bool) => {
    return s.map(i => {
      return G(i, bool)
    })
  }
  const G = (i, bool) => {
    i.disabled = bool
    // 如果有子级
    if (i.children && i.children !== undefined) {
      R(i.children, bool)
    }
    return i
  }
  return R(s, bool)
}
// 清空树数据null值
export function TreeDataNull(data) {
  const R = (data) => {
    return data.map(i => {
      return G(i)
    })
  }
  const G = (i) => {
    if (i.children) {
      if (i.children.length < 1) {
        i.children = undefined
      } else {
        R(i.children)
      }
    }
    return i
  }
  return R(data)
}



// WEBPACK FOOTER //
// ./src/utils/tool.js